exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-73dccc34] table.v-table thead th:nth-child(1) {\n  width: 20px;\n  padding-right: 0;\n}\n[data-v-73dccc34] table.v-table tbody tr td:nth-child(1) {\n  width: 20px;\n  padding-right: 0;\n}\n[data-v-73dccc34] .v-chip .v-chip__content {\n  height: 25px;\n}\n[data-v-73dccc34] .icheckbox_square-green {\n  display: none;\n}\n", ""]);

// exports
